import { Component, Input } from '@angular/core';
import { Category } from '../../../app/app.interfaces';

@Component({
  selector: 'post-category-list',
  templateUrl: 'post-category-list.html'
})

export class PostCategoryList {
  @Input() categories: Category[];
}



// WEBPACK FOOTER //
// ./src/partials/category/post-category-list/post-category-list.ts